
import BigOnBreakfast from './BigOnBreakfast';
import GenerousBigMeals from './GenerousBigMeals';
import PerfectedDrinks from './PerfectedDrinks';
import DecadentDessert from './DecadentDessert';

const MainJson = 

[
    BigOnBreakfast,
    GenerousBigMeals,
    PerfectedDrinks, 
    DecadentDessert 
 
]

export default MainJson;
